"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.faq = void 0;
var faqsListUrl = '/faqs/public';
exports.faq = function (axios) {
    return {
        // [FAQ]
        getFaqsPublic: function (getFaqsPublicRequest) {
            return axios.get(faqsListUrl, getFaqsPublicRequest);
        },
        getFaqsPublicFaqNo: function (getFaqsPublicFaqNoRequest) {
            var url = faqsListUrl + "/" + getFaqsPublicFaqNoRequest.pathParams.faqNo;
            return axios.get(url);
        }
    };
};
